import React from 'react'

// Components
import { useModalContext, useResponsiveDropdown } from '@sketch/components'

// Local Components
import { ManageCollectionModal } from '../../modals'
import { CollectionDropdownContent } from '../CollectionDropdown'

// Styles
import {
  HeaderButton,
  Dots,
  ButtonWrapper,
} from 'modules/projects/components/ProjectHeader/ProjectHeader.styles'

// Types
import { CollectionHeaderActionsProps } from './types'

export const CollectionHeaderActions: React.FC<CollectionHeaderActionsProps> = ({
  project,
  workspace,
  collection,
  userCanManageCollection,
}) => {
  const { showModal } = useModalContext()

  const [content, buttonProps] = useResponsiveDropdown({
    dropdown: CollectionDropdownContent,
    dropdownProps: {
      workspace,
      project,
      collection,
      userCanManageCollection,
    },
    usePortal: true,
    placement: 'bottom-start',
  })

  const handleManageCollection = () => {
    showModal(ManageCollectionModal, {
      project,
      collection,
    })
  }

  return (
    <ButtonWrapper>
      <HeaderButton onClick={handleManageCollection}>
        Manage Collection
      </HeaderButton>
      <>
        <HeaderButton {...buttonProps} data-testid="collection-other-actions">
          <span className="sr-only">Other Actions</span>
          <Dots />
        </HeaderButton>
        {content}
      </>
    </ButtonWrapper>
  )
}
